<template>
  <div class="notice-board--page">
    <div class="notice-board">
      <div class="title">供应看板</div>
      <!-- <div v-loading="loading">
        <el-tabs
          v-model="activeName1"
          class="el-tabs__customize notice-board-tabs"
          @tab-click="handleClickOne"
          :lazy="false"
        >
          <el-tab-pane
            v-for="(item, index) in list1"
            :key="index"
            :name="`tab${index}`"
            :label="item.name"
          > -->
      <boardecharts></boardecharts>
      <!-- </el-tab-pane>
        </el-tabs> -->
      <!-- </div> -->
      <el-link
        :underline="false"
        type="info"
        class="notice-more"
        @click="handleViewAll()"
      >
        更多 ></el-link
      >
    </div>

    <div class="towBox"></div>
  </div>
</template>

<script>
import { announcementPageSource } from "@/setting/setting";
import boardecharts from "./boardecharts";
export default {
  name: "noticeBoard",
  components: {
    boardecharts
  },
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      hoverIndex: null,
      showChart: false,
      list1: [
        // {
        //   name: "供应看板"
        // }
      ],
      list2: [],
      list3: [],
      loading: false,
      priceList: [],
      addressOptions: [],
      data: [10, 20, 30, 40, 50],
      addressValue: "",
      childrenList2: [],
      activeName1: "tab0",
      activeName2: "tab0",
      source: announcementPageSource,
      marketDynamicUrl: "",
      priceInfoUrl: "",
      pageNo: 1,
      total: 0,
      imspAgentId: "",
      interfaceType: "4" // 获取市场动态下的：分析报告、市场详情、行业要闻  默认是：分析报告
    };
  },
  mounted() {},
  activated() {},
  deactivated() {
    this.list1 = [];
    this.list2 = [];
    this.list3 = [];
    this.priceList = [];
    this.childrenList2 = [];
    this.activeName1 = "tab0";
    this.activeName2 = "tab0";
    this.marketDynamicUrl = "";
    this.priceInfoUrl = "";
  },
  beforeDestroy() {},
  methods: {
    init(code, pageNo, type) {},
    handleViewAll() {
      let href = "";
      this.imspAgentId = JSON.parse(
        localStorage.getItem("agentIdList")
      ).imspAgentId;
      if (this.baseUrl.indexOf("dev01") != -1) {
        href = `https://dev01-smpbd.iccec.cn/screen/purchase?a=${this.imspAgentId}`;
      } else if (this.baseUrl.indexOf("test01") != -1) {
        href = `https://test01-smpbd.iccec.cn/screen/purchase?a=${this.imspAgentId}`;
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        href = `https://uat01-smpbd.iccec.cn/screen/purchase?a=${this.imspAgentId}`;
      } else {
        href = `https://smpbd.iccec.cn/screen/purchase?a=${this.imspAgentId}`;
      }
      window.open(href, "_blank");
    },
    handleClickOne(tab) {}
  }
};
</script>

<style scoped lang="scss">
.notice-board--page {
  position: relative;
  height: 747px;
  background: #ffffff;
  margin-top: 20px;
  padding-top: 8px;
}
.title {
  font-weight: 600;
  font-size: 20px;
  color: #4a4a4a;
  line-height: 28px;
  text-align: left;
  margin: 10px 20px 17px 20px;
}
.notice-more {
  position: absolute;
  top: 17px;
  right: 20px;
  line-height: 30px;
  &:hover {
    color: #0089ef;
  }
}
/deep/ .el-tabs__content {
  overflow: visible !important;
}
/deep/.el-tabs__nav-wrap {
  padding-top: 3px;
  padding-right: 60px;
  left: 45%;
}
/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-prev {
  line-height: 24px;
}

/deep/ .el-tabs__nav-next {
  line-height: 24px;
  right: 40px;
}
/deep/ .el-tabs__item {
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
  margin-right: 10px;
  min-width: 88px;
  height: 36px;
  line-height: 36px;
  border-radius: 16px;
  box-sizing: border-box;
}
/deep/ .is-active {
  color: #ffffff;
}

/deep/ .el-tabs__item:hover {
  color: #0089ef;
  background: rgba(0, 137, 239, 0.06);
  border: 1px solid #0089ef;
  border-radius: 16px;
}
/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  background: #0089ef;
  border-radius: 16px;
  border: none;
  border: 1px solid #0089ef;
}
</style>
